// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buybox[data-v-f5582076]{border-radius:8px}.buybox .offer-container[data-v-f5582076]:nth-child(2n){background:#111924}.buybox .offer-container[data-v-f5582076]:nth-child(2n) .pp-exp-qtv{--fade-color:#111924}.buybox .offer-container[data-v-f5582076]:nth-child(2n-1){background:#0c131e}.buybox .offer-container[data-v-f5582076]:nth-child(2n-1) .pp-exp-qtv{--fade-color:#0c131e}.buybox .offer-container--other[data-v-f5582076]{display:none}", ""]);
// Exports
module.exports = exports;
